<template>
  <footer class="app-footer bg-light">
    <div class="footer-content">
      <!-- Official Badge -->
      <div class="footer-branding">
        <div class="logo-container">
          <i class="fas fa-shield-alt"></i>
        </div>
        <div class="brand-info">
          <span class="app-name">Emergency Response System</span>
          <span class="government-text">Palompon Municipal Government</span>
        </div>
      </div>

      <!-- Copyright and Links -->
      <div class="footer-main">
        <div class="copyright">&copy; {{ currentYear }} All Rights Reserved</div>

        <div class="footer-links">
          <a href="#" class="footer-link">
            <i class="fas fa-user-shield"></i> Privacy Policy
          </a>
          <a href="#" class="footer-link">
            <i class="fas fa-file-contract"></i> Terms of Use
          </a>
          <a href="#" class="footer-link">
            <i class="fas fa-question-circle"></i> Help Center
          </a>
        </div>
      </div>

      <!-- Developer Credits -->
      <div class="d-flex justify-content-center w-100">
        <span class="text-danger me-2"
          ><i class="fas fa-bolt" style="color: #ff4d4d"></i> Powered By:
        </span>
        <a href="#" class="dev-link">Exodous I.T. Solutions</a>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from "vue";

const currentYear = computed(() => new Date().getFullYear());
</script>

<style scoped>
.app-footer {
  background: linear-gradient(135deg, #e0e0e0 0%, #d3d1d1 100%);
  color: rgba(255, 255, 255, 0.8);
  padding: 2rem 1rem;
  font-size: 0.9rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.footer-branding {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.logo-container {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-container i {
  font-size: 1.5rem;
  color: white;
}

.brand-info {
  display: flex;
  flex-direction: column;
}

.app-name {
  font-weight: 600;
  color: rgba(43, 25, 25, 0.8);
  font-size: 1.1rem;
}

.government-text {
  font-size: 0.8rem;
  opacity: 0.8;
  color: rgba(43, 25, 25, 0.8);
}

.footer-main {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.copyright {
  opacity: 0.7;
  color: #b71c1c;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.footer-link {
  color: rgba(43, 25, 25, 0.8);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: color 0.2s;
}

.footer-link:hover {
  color: rgb(56, 13, 13);
}

.footer-link i {
  font-size: 0.9rem;
}

.dev-link {
  color: rgba(43, 25, 25, 0.8);
  text-decoration: none;
  transition: color 0.2s;
}

.dev-link:hover {
  color: #ff4d4d;
  text-decoration: underline;
}

/* Responsive Design */
@media (min-width: 768px) {
  .footer-content {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .footer-main {
    flex-direction: row;
    align-items: center;
    gap: 2rem;
    border-bottom: none;
    padding-bottom: 0;
  }

  .footer-branding {
    margin-bottom: 0;
  }
  .credits {
    justify-content: center; /* Original alignment */
    width: 100%; /* Reverts width */
    text-align: center; /* Reverts text alignment */
  }
}

@media (min-width: 1024px) {
  .app-footer {
    padding: 2rem;
  }
}
</style>
